/* ── MOBILE MENU ── */
document.addEventListener('DOMContentLoaded', function () {
  var hamburgerBtn = document.getElementById('hamburgerBtn');
  var mobileMenu = document.getElementById('mobileMenu');
  var mobileMenuClose = document.getElementById('mobileMenuClose');
  if (hamburgerBtn) hamburgerBtn.addEventListener('click', function () { mobileMenu.classList.add('open'); });
  if (mobileMenuClose) mobileMenuClose.addEventListener('click', function () { mobileMenu.classList.remove('open'); });
  if (mobileMenu) mobileMenu.addEventListener('click', function (e) {
    if (e.target === mobileMenu) mobileMenu.classList.remove('open');
  });

  /* ── HERO SLIDER ── */
  var slideTrack = document.getElementById('slideTrack');
  if (slideTrack) {
    var slides = slideTrack.querySelectorAll('.slide');
    var dotsContainer = document.getElementById('sliderDots');
    var current = 0;
    var autoPlay;

    slides.forEach(function (_, i) {
      var dot = document.createElement('button');
      dot.className = 'slider-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function () { goTo(i); });
      dotsContainer.appendChild(dot);
    });

    function goTo(n) {
      current = (n + slides.length) % slides.length;
      slideTrack.style.transform = 'translateX(-' + (current * 100) + '%)';
      document.querySelectorAll('.slider-dot').forEach(function (d, i) {
        d.classList.toggle('active', i === current);
      });
    }

    var nextBtn = document.getElementById('nextSlide');
    var prevBtn = document.getElementById('prevSlide');
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetAuto(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetAuto(); });

    function resetAuto() { clearInterval(autoPlay); autoPlay = setInterval(function () { goTo(current + 1); }, 4000); }
    autoPlay = setInterval(function () { goTo(current + 1); }, 4000);
  }

  /* ── COUNTDOWN TIMER ── */
  var countdownEl = document.getElementById('countdown');
  if (countdownEl) {
    var endAttr = countdownEl.getAttribute('data-end');
    var endTime = endAttr ? parseInt(endAttr, 10) : (Date.now() + 24 * 3600 * 1000);
    var tick = setInterval(function () {
      var diff = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
      if (diff <= 0) { clearInterval(tick); countdownEl.textContent = 'EXPIRED'; return; }
      var h = String(Math.floor(diff / 3600)).padStart(2, '0');
      var m = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
      var s = String(diff % 60).padStart(2, '0');
      countdownEl.textContent = h + 'H:' + m + 'M:' + s + 'S';
    }, 1000);
  }

  /* ── ADD TO BAG via Shopify AJAX ── */
  var toastEl = document.getElementById('toastMsg');
  var cartCountEl = document.getElementById('cartCount');
  var toastTimer;

  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg || '✅ Added to Bag!';
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 2500);
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (cartCountEl) cartCountEl.textContent = data.item_count;
      }).catch(function () {});
  }

  document.querySelectorAll('.add-to-bag-btn[data-variant-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) { showToast('⚠ No variant found'); return; }
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) { showToast('⚠ ' + (data.description || 'Error')); }
          else { showToast('✅ Added to Bag!'); updateCartCount(); }
          btn.disabled = false; btn.textContent = 'Add to Bag';
        })
        .catch(function () { showToast('⚠ Something went wrong'); btn.disabled = false; btn.textContent = 'Add to Bag'; });
    });
  });

  /* Quantity buttons on product page */
  var qtyInput = document.getElementById('quantityInput');
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var val = parseInt(qtyInput.value, 10) || 1;
      if (btn.classList.contains('qty-minus') && val > 1) qtyInput.value = val - 1;
      if (btn.classList.contains('qty-plus')) qtyInput.value = val + 1;
    });
  });

  updateCartCount();
});
